import $ from "jquery";
import "slick-carousel";
import "fslightbox";

const productGalleriesSlider = () => {

  const target = ".product-galleries";
  const $target = $(target);

  const init = () => {
      if ($target.length) {
          exec();
      }
  };

  const exec = () => {

    const el = {
      for : '.product-galleries-for',
      nav : '.product-galleries-nav'
    }

    $(el.for).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: el.nav
    });

    $(el.nav).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: el.for,
      dots: false,
      arrows: false,
      centerMode: true,
      focusOnSelect: true,
      infinite: true,
      variableWidth: true,
      responsive: [
            {
            breakpoint: 810,
              settings: {
            slidesToShow: 2,
          }
        },
      ]
    });
  };
  
  init();
};

try {
  productGalleriesSlider();
} catch (error) {
  throw Error(error);
}

